export default __webpack_public_path__ + "static/home-health_testimonial-90a7b660cd0247c2174bf21a38dc9506.jpg";